import { render, staticRenderFns } from "./BackendNav.vue?vue&type=template&id=3f1ba22c&scoped=true&"
import script from "./BackendNav.vue?vue&type=script&lang=js&"
export * from "./BackendNav.vue?vue&type=script&lang=js&"
import style0 from "./BackendNav.vue?vue&type=style&index=0&id=3f1ba22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ba22c",
  null
  
)

export default component.exports